<template>
  <Modal size="small" @modalClose="onClose">
    <div class="modal-header">
      <h4>สร้างเทมเพลตใหม่</h4>
      <router-link
        :to="'/schedule-templates'"
        class="btn btn-link btm-sm btn-close-container">
        <i class="fas fa-times"></i>
      </router-link>
    </div>
    <form v-on:submit.prevent="onSubmit">
      <div class="modal-body">
        <FormGroup :errorMessage="createScheduleTemplateState.error.name">
          <h5 class="name">ชื่อ</h5>
          <input
            type="text"
            placeholder="ระบุชื่อเทมเพลต"
            class="form-control"
            :class="{'is-invalid': createScheduleTemplateState.error.name }"
            v-model="scheduleTemplate.name"
            @blur="checkRequired" />
          <div
            class="invalid-feedback"
            v-if="createScheduleTemplateState.error.name">
            ระบุชื่อเทมเพลต
          </div>
        </FormGroup>
        <FormGroup>
          <h5 class="name">เทมเพลต</h5>
          <SelectOption
            :value="scheduleTemplate.duplicateFromtemplateId"
            :options="templates"
            :customLabel="'name'"
            :placeholder="'เลือกเทมเพลต'"
            @onChanged="onSelectedTemplate"
            @onSearch="loadscheduleTemplates" />
        </FormGroup>
      </div>
      <div class="modal-footer">
        <router-link
          :to="'/schedule-templates'"
          class="btn btn-link pl-0">
          ยกเลิก
        </router-link>
        <button type="submit"
          class="btn btn-primary"
          :disabled="!isValid">สร้าง
        </button>
      </div>
    </form>
  </Modal>
</template>

<script>
import Modal from '@/components/Modal.vue';
import FormGroup from '@/components/FormGroup.vue';
import SelectOption from '@/components/SelectOption.vue';

import { loadscheduleTemplates, createScheduleTemplate } from './api';

export default {
  props: {
    onClose: {
      type: Function,
      default: () => {},
    },
    onUpdated: {
      type: Function,
      default: () => {},
    },
  },
  components: {
    Modal,
    FormGroup,
    SelectOption,
  },
  data() {
    return {
      templates: [],
      scheduleTemplate: {
        name: null,
        duplicateFromtemplateId: null,
      },
      createScheduleTemplateState: {
        isSaving: false,
        isSaved: false,
        error: {
          name: null,
        },
      },
    };
  },
  created() {
    this.loadscheduleTemplates();
  },
  computed: {
    isValid() {
      return this.scheduleTemplate.name && !this.createScheduleTemplateState.isSaving;
    },
  },
  methods: {
    async loadscheduleTemplates(filter) {
      const response = await loadscheduleTemplates(filter);
      this.templates = response.data.data;
    },
    async onSubmit() {
      this.createScheduleTemplateState.isSaving = true;
      this.createScheduleTemplateState.isSaved = false;
      try {
        const response = await createScheduleTemplate(this.scheduleTemplate);
        this.createScheduleTemplateState.isSaving = false;
        this.createScheduleTemplateState.isSaved = true;
        this.$router.push(`/schedule-templates/${response.data.id}`);
      } catch (error) {
        this.createScheduleTemplateState.isSaving = false;
        this.createScheduleTemplateState.error = error.response.data;
      }
    },
    checkRequired(event) {
      if (!event.target.value) {
        this.createScheduleTemplateState.error = {
          ...this.createScheduleTemplateState.error,
          name: 'ระบุชื่อเทมเพลต',
        };
      } else {
        this.createScheduleTemplateState.error = {
          ...this.createScheduleTemplateState.error,
          name: null,
        };
      }
    },
    onSelectedTemplate(selectOption) {
      this.scheduleTemplate.duplicateFromtemplateId = selectOption;
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/variables.scss';

.modal-body {
  overflow: initial;
}
</style>
